export interface Customer_Interface {

  id:number,
  code:string,
  shenasehMeli:string,
  type:number,
  name:string,
  name_en:string,
  city_id:number,
  province_id:string,
  feildActivity_id:number,
  shomarehSabt:number,
  codeEghtesadi:number,
  codeMeli:number,

  modirAmelName:string,
  modirAmelMobile:number,
  modirAmelTel:number,
  modirAmelDakheli:number,
  modirAmelEmail:string,

  special:boolean,
  foreign:boolean,
}

export function Empty_Customer_Interface():Customer_Interface{
  return{
    id:0,
    code:'',
    shenasehMeli:'',
    type:0,
    name:'',
    name_en:'',
    province_id:'',
    city_id:0,
    feildActivity_id:0,
    shomarehSabt:0,
    codeEghtesadi:0,
    codeMeli:0,

    modirAmelName:'',
    modirAmelMobile:0,
    modirAmelTel:0,
    modirAmelDakheli:0,
    modirAmelEmail:'',

    special:false,
    foreign:false,
  }
}
